import { render, staticRenderFns } from "./trilha-atividade.vue?vue&type=template&id=12213b2f"
import script from "./trilha-atividade.vue?vue&type=script&lang=js"
export * from "./trilha-atividade.vue?vue&type=script&lang=js"
import style0 from "./trilha-atividade.vue?vue&type=style&index=0&id=12213b2f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports